var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDepletable = function SvgDepletable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 30.817c0-.316.156-.613.416-.794l18.382-12.776a.968.968 0 0 1 1.105 0l18.382 12.776c.26.18.416.478.416.794v28.316a.967.967 0 0 1-.968.968H10.368a.967.967 0 0 1-.968-.968V30.817Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.358 32.699v25.844a2 2 0 0 0 2 2H45.98a2 2 0 0 0 2-2V31.28a2 2 0 0 0-.862-1.644l-17.08-11.825a2 2 0 0 0-2.257-.014l-17.54 11.84a2 2 0 0 0-.882 1.658v.616",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.754 30.114a1.105 1.105 0 0 1 .222-1.606l25.948-18.163c.424-.297.99-.294 1.411.007l25.358 18.112c.558.4.679 1.18.267 1.729l-3.501 4.668c-.4.534-1.155.648-1.696.256L29.328 20.302a1.222 1.222 0 0 0-1.407-.02L6.9 34.638a1.222 1.222 0 0 1-1.635-.235l-3.51-4.29Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.579 17.586 9.906-6.934a2 2 0 0 1 2.294 0L54.48 27.944a2 2 0 0 1 .39 2.919l-2.937 3.524a2 2 0 0 1-2.71.339L29.79 20.638a2 2 0 0 0-2.329-.014L7.562 34.7a2 2 0 0 1-2.755-.433L2.24 30.845a2 2 0 0 1 .453-2.839l9.36-6.551",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.336 43.278h-13.48a1 1 0 0 0-1 1v16.265h15.48V44.278a1 1 0 0 0-1-1Z",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m63.402 13.841-1.733 1.607a1.105 1.105 0 0 0-.03 1.592l1.547 1.547c.42.42 1.097.433 1.533.03l1.733-1.608c.46-.426.473-1.149.03-1.592l-1.547-1.547a1.105 1.105 0 0 0-1.533-.029Z",
    fill: "#E5E5E5",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.957,
    cy: 31.211,
    r: 19.644,
    fill: "#E76565",
    stroke: "#000",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.956,
    cy: 31.211,
    r: 16.71,
    fill: "#EAFFE6",
    stroke: "#000",
    strokeWidth: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.956,
    cy: 32.188,
    r: 3.022,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.468 19.967a.489.489 0 1 1 .977 0v8.8a.489.489 0 0 1-.977 0v-8.8ZM48.468 9.212a.489.489 0 1 1 .977 0v1.955a.489.489 0 0 1-.977 0V9.212ZM59.223 31.7a.489.489 0 0 1 0 .977h-6.844a.489.489 0 1 1 0-.977h6.844Z",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.58 6.323a2 2 0 0 1 2-2h6.754a2 2 0 0 1 2 2v.889a2 2 0 0 1-2 2H45.58a2 2 0 0 1-2-2v-.889Z",
    fill: "#E5E5E5",
    stroke: "#000",
    strokeWidth: 0.8
  })));
};
export default SvgDepletable;